<template>
	<v-card class="card-rounded elevation-1 mb-3 justify-bottom text-left" style="width: 100%">
		<v-list-item three-line>
			<v-list-item-content>
				<v-list-item-title class="mb-1"
					><h2>{{ value }}% complete</h2></v-list-item-title
				>
				<!-- <v-list-item-subtitle v-if="levels && level in levels && level > 0">Level {{ level }}: {{ levels[level].top }}</v-list-item-subtitle> -->
				<v-list-item-subtitle v-if="levels && level in levels && level > 0"> {{ levels[level].top }}</v-list-item-subtitle>
				<v-spacer></v-spacer>
				<v-progress-linear
					:active="true"
					:background-opacity="0.15"
					:height="24"
					:striped="false"
					:rounded="true"
					:value="value"
					background-color="grey"
					class="progress-rounded"
					:buffer-value="value + 10"
				>
				</v-progress-linear>
				<v-list-item-subtitle v-if="levels && level in levels && level > 0" style="color: #508da7" class="pt-2">
					<!-- <strong> {{ steps - step }} step{{ steps - step > 1 ? 's' : '' }} away from level {{ level }}: </strong> -->
					{{ levels[level].bottom }}
				</v-list-item-subtitle>
			</v-list-item-content>
		</v-list-item>
	</v-card>
</template>

<script>
import { bus } from '@/main';
import store from '@/store';

export default {
	components: {},
	data: () => ({
		initial: 0,
	}),

	computed: {
		levels: function () {
			return store.getters.getLevels ? store.getters.getLevels : [];
		},

		level: function () {
			if (store.getters.getNextSignupStep != false) {
				return 1;
			} else if (store.getters.getNextBoosterSignupStep != false) {
				return 2;
			} else {
				return 2;
			}
		},
		steps: function () {
			if (this.level > 0) {
				if (this.level == 1) {
					return store.getters.stepsRequired.length;
				} else if (this.level == 2) {
					return store.getters.stepsBoosted.length;
				}
			}
			return 0;
		},
		step: function () {
			let count = 0;
			if (this.level > 0) {
				if (this.level == 1) {
					count++; //we force +1 since we account oen step allways done technically
					store.getters.stepsRequired.forEach(step => {
						if (step.status) {
							count++;
						}
					});
				} else if (this.level == 2) {
					store.getters.stepsBoosted.forEach(step => {
						if (step.status) {
							count++;
						}
					});
				}
			}
			return count;
		},

		value: function () {
			// let total = store.getters.stepsRequired.length + store.getters.stepsBoosted.length;
			let count = 0;
			store.getters.stepsRequired.forEach(step => {
				if (step.status) {
					count++;
				}
			});
			store.getters.stepsBoosted.forEach(step => {
				if (step.status) {
					count++;
				}
			});
			return Math.min(100, count * 10 + 10 + (store.getters.getIsApproved ? 10 : 0) + (store.getters.currentStep == 'completed-step' ? 10 : 0)); //+10 for initial step thats guarenteed to be done
		},
	},

	created() {
		bus.$on('update:progressbar@add', increment => {
			this.value += Math.min(increment, 100); //clamp to 100.
		});
		bus.$on('steps@refresh', () => {
			this.value = this.initial;
		});
		bus.$on('update:progressbar@steps', steps => {
			this.steps = steps;
		});
		bus.$on('account:step@register', () => {
			//increase the total step counter
			this.steps = this.steps + 1;
		});
		bus.$on('update:progressbar@levels', new_levels => {
			this.levels = new_levels;
		});
		bus.$on('update:progressbar@set-step', step => {
			this.step = step;
			// this.step = Math.max(this.step,1); //clamp to 1 or higher
		});

		bus.$on('update:progressbar@step', () => {
			this.step = this.step + 1;
			this.step = Math.min(this.steps, this.step); //clamp to max
		});
	},

	methods: {
		SubmitForm() {
			bus.$emit('intent:submit-forms');
		},
	},
};
</script>
